import { render, staticRenderFns } from "./UpdateStatus.vue?vue&type=template&id=675c65e7&"
import script from "./UpdateStatus.vue?vue&type=script&lang=ts&"
export * from "./UpdateStatus.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports